export default function formatRequestState(state: string) {
  switch (state) {
    case 'PENDING':
      return 'Pendiente'
    case 'REJECTED':
      return 'Rechazado'
    case 'APPROVED':
      return 'Aprobado'
    case 'GENERATED':
      return 'Generado'
    default:
      return 'Pendiente'
  }
}
